module.exports = __webpack_public_path__ + "img/facebook.f8b25949.svg";